import { useCartDefaultMutations } from '@/composables/useCartDefaultMutations'

export default {
  ...useCartDefaultMutations(),
}